export default "__VITE_ASSET__CGT2q$FR__"